import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { networkErrorHelper } from "libs";
import { withRouter } from "react-router-dom";
import { MTable } from "components/table";
import { Col, Container, Row } from "design-react-kit";
import { revisionService } from "libs/api/revisionService";
import { getCurrentRevisor } from "store/actions";
import { LESSON_ACTIVITY_TYPES } from "const";

class ReviewPendingLA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rndKey: 0,
      payload: [],
      revisorId: null,
    };
  }

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
      {
        id: "revisionNote",
        Header: "Note revisione",
        accessor: "revisionNote",
      },
    ],
    actions: [],
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props.match.params;
    const revisor = getCurrentRevisor(context);

    const revisorId = revisor?.id;
    if (revisorId) {
      this.setState({ revisorId });
      this.loadRemote(revisorId);
    } else this.loadRemote();
  }

  componentDidUpdate(prevProps) {
    const { activityType } = this.props.match.params;
    const { revisorId } = this.state;

    if (prevProps.match.params.activityType !== activityType) {
      this.loadRemote(revisorId);
    }
  }

  loadRemote(revisorId) {
    this.setState({ loading: true });

    const { activityType, status } = this.props.match.params;

    const filter = {
      status,
      revisorId,
      lessonType: "training",
      activityType,
    };

    revisionService
      .listAllLessonActivity(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push({
            ...val,
            revisionNote: val.revision?.revisionNote || null,
          });
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
            loadingError: true,
          });
        }
      });
  }

  //--- ---

  render() {
    const { loading } = this.state;
    const { activityType } = this.props.match.params;

    return (
      <>
        <Row>
          <Col md={6}>
            <Title
              subtitle={
                activityType === LESSON_ACTIVITY_TYPES.ABILITAZIONI
                  ? "Percorsi Abilitanti"
                  : activityType === LESSON_ACTIVITY_TYPES.TFA_INDIRE
                    ? "TFA Indire"
                    : "TFA Classico"
              }
            >
              Storico Revisioni Non Idonee
            </Title>
          </Col>
        </Row>

        <hr />

        <section className="my-3">
          {loading ? (
            <MnemoLoading />
          ) : (
            <Container>
              <MTable key={this.state.rndKey} tableData={this.state.payload} tableConfig={this.tableConfig} />
            </Container>
          )}

          {this.state.payload.length === 0 && (
            <BoxDanger key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare in database.</div>
            </BoxDanger>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewPendingLA);
